import HotspotModel from "../../models/standard/HotspotModel";

// Helper function to serialize a hotspot.
export function serializeHotspot(h: HotspotModel) {
  return {
    uuid: h.uuid,
    id: h.id,
    position: {
      x: h.position.x,
      y: h.position.y,
      z: h.position.z,
    },
    attachment: h.attachment.toJSON(),
    creationDate: h.creationDate.toISOString(),
    userId: h.userId,
  };
}
